export default __webpack_public_path__ + "static/media/buttons.e3680556.png";